module.exports = __webpack_public_path__ + "static/media/points-portal4.6cef7604.6cef7604.JPG";